import type { FieldDef } from '@/config/masterData';

type Values = Record<string, unknown>;

/** Blank record from the descriptor defaults. */
export function emptyValues(fields: FieldDef[]): Values {
  const v: Values = {};
  for (const f of fields) {
    v[f.name] = f.default ?? (f.type === 'boolean' ? false : null);
  }
  return v;
}

/** Client-side validation. The database is still the authority — this only
 *  saves a round trip on the obvious cases. */
export function validate(fields: FieldDef[], values: Values): Record<string, string> {
  const errors: Record<string, string> = {};
  for (const f of fields) {
    const v = values[f.name];
    if (f.required && (v === null || v === undefined || v === '')) {
      errors[f.name] = `${f.label} is required`;
      continue;
    }
    if (f.type === 'number' && v !== null && v !== undefined && v !== '') {
      const n = Number(v);
      if (!Number.isFinite(n)) errors[f.name] = 'Must be a number';
      else if (f.min !== undefined && n < f.min) errors[f.name] = `Minimum is ${f.min}`;
      else if (f.max !== undefined && n > f.max) errors[f.name] = `Maximum is ${f.max}`;
    }
  }
  return errors;
}
